import React from 'react';

const GenderFilter = ({ gender, setGender }) => {
  const handleSelect = (value) => {
    setGender(gender.includes(value) ? [] : [value]);
  };

  return (
    <div className="d-flex flex-wrap justify-content-center">
      {['male', 'female'].map((g) => (
        <React.Fragment key={g}>
          <input
            type="radio"
            className="btn-check"
            id={`gender-${g}`}
            name="gender"
            value={g}
            checked={gender.includes(g)}
            onClick={() => handleSelect(g)}
            onChange={() => {}}
          />
          <label htmlFor={`gender-${g}`} className="btn-filterSize px-3">
            {g === 'male' ? 'Junge' : 'Mädchen'}
          </label>
        </React.Fragment>
      ))}
    </div>
  );
};

export default GenderFilter;
